import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useEntitiesContext } from '../../context';
import { EntityAgenticTriageReportProvider } from '../../context';
import { useEntityAnalysisModalKeyboard } from '../../hooks';
import {
  EntityAnalysisMainView,
  KeyFindingsView,
  KeyFindingsDetailView,
  PlaybookView,
} from './views';
import { ModalView } from '../../types';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const EntityAnalysisModal: React.FC = () => {
  const {
    analysisModal: {
      isOpen,
      onClose,
      activeTab,
      setActiveTab,
      modalNavigation,
    },
  } = useEntitiesContext();
  const location = useLocation();
  const { currentView } = modalNavigation;

  // Enable keyboard shortcuts
  useEntityAnalysisModalKeyboard({
    isOpen,
    onClose,
    setActiveTab,
    activeTab,
  });

  const renderModalView = (view: ModalView) => {
    switch (view) {
      case ModalView.Main:
        return <EntityAnalysisMainView />;
      case ModalView.KeyFindings:
        return <KeyFindingsView />;
      case ModalView.KeyFindingsDetail:
        return <KeyFindingsDetailView />;
      case ModalView.Playbook:
        return <PlaybookView />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const unlisten = () => {
      onClose(); // Cloase modal when the route changes
    };

    return unlisten;
  }, [location]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true} size="full">
      <ModalOverlay />
      <ModalContent
        w="95vw"
        h="90vh"
        maxW="1280px"
        maxH="90vh"
        minH="90vh"
        display="flex"
        flexDirection="column"
      >
        <EntityAgenticTriageReportProvider>
          {renderModalView(currentView)}
        </EntityAgenticTriageReportProvider>
      </ModalContent>
    </Modal>
  );
};
